/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/*
* When adding modules to the namespace, ensure that they are added in alphabetical order according to module name.
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-read-only-property';


// MAIN //

/**
* Top-level namespace.
*
* @namespace kumaraswamy
*/
var kumaraswamy = {};

/**
* @name cdf
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/cdf}
*/
import cdf from './../../../../base/dists/kumaraswamy/cdf';
setReadOnly( kumaraswamy, 'cdf', cdf );

/**
* @name Kumaraswamy
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/ctor}
*/
import Kumaraswamy from './../../../../base/dists/kumaraswamy/ctor';
setReadOnly( kumaraswamy, 'Kumaraswamy', Kumaraswamy );

/**
* @name kurtosis
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/kurtosis}
*/
import kurtosis from './../../../../base/dists/kumaraswamy/kurtosis';
setReadOnly( kumaraswamy, 'kurtosis', kurtosis );

/**
* @name logcdf
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/logcdf}
*/
import logcdf from './../../../../base/dists/kumaraswamy/logcdf';
setReadOnly( kumaraswamy, 'logcdf', logcdf );

/**
* @name logpdf
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/logpdf}
*/
import logpdf from './../../../../base/dists/kumaraswamy/logpdf';
setReadOnly( kumaraswamy, 'logpdf', logpdf );

/**
* @name mean
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/mean}
*/
import mean from './../../../../base/dists/kumaraswamy/mean';
setReadOnly( kumaraswamy, 'mean', mean );

/**
* @name median
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/median}
*/
import median from './../../../../base/dists/kumaraswamy/median';
setReadOnly( kumaraswamy, 'median', median );

/**
* @name mode
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/mode}
*/
import mode from './../../../../base/dists/kumaraswamy/mode';
setReadOnly( kumaraswamy, 'mode', mode );

/**
* @name pdf
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/pdf}
*/
import pdf from './../../../../base/dists/kumaraswamy/pdf';
setReadOnly( kumaraswamy, 'pdf', pdf );

/**
* @name quantile
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/quantile}
*/
import quantile from './../../../../base/dists/kumaraswamy/quantile';
setReadOnly( kumaraswamy, 'quantile', quantile );

/**
* @name skewness
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/skewness}
*/
import skewness from './../../../../base/dists/kumaraswamy/skewness';
setReadOnly( kumaraswamy, 'skewness', skewness );

/**
* @name stdev
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/stdev}
*/
import stdev from './../../../../base/dists/kumaraswamy/stdev';
setReadOnly( kumaraswamy, 'stdev', stdev );

/**
* @name variance
* @memberof kumaraswamy
* @readonly
* @type {Function}
* @see {@link module:@stdlib/stats/base/dists/kumaraswamy/variance}
*/
import variance from './../../../../base/dists/kumaraswamy/variance';
setReadOnly( kumaraswamy, 'variance', variance );


// EXPORTS //

export default kumaraswamy;
